export enum SalesDistrict {
    AlcroSweden = "SE1",
    BeckersSweden = "SE2",
    Norway = "NO",
}
